import React, { useState } from 'react';
import GeneralInsuranceList from '../GeneralInsuranceList.jsx';
import { GIPayoutsSubTab } from './GIPayoutsSubTab.jsx';
import { GIMonthlySummarySubTab } from './GIMonthlySummarySubTab.jsx';
import GIPoliciesCommissionSubTab from './GIPoliciesCommissionSubTab.jsx';

// General Insurance Tab Component with Sub-tabs
export const GeneralInsuranceTab = ({ userRole, user }) => {
    const [activeSubTab, setActiveSubTab] = useState('applications');

    // Define sub-tabs based on user role
    const subTabs = [
        { id: 'applications', label: 'Applications' },
        // Only show "My Policies & Commission" for advisors and leaders and health_plus_partner
        ...(userRole === 'advisor' || userRole === 'leader' || userRole === 'health_plus_partner'
            ? [{ id: 'my-policies', label: 'My Policies & Commission' }]
            : []
        ),
        ...(userRole !== 'advisor' && userRole !== 'health_plus_partner'
            ? [{ id: 'payouts', label: 'Payouts' }]
            : []
        ),
        // Only show Monthly Summary for super_admin and leaders
        ...(userRole === 'super_admin' || userRole === 'leader'
            ? [{ id: 'monthly-summary', label: 'Monthly Summary' }]
            : []
        )
    ];

    return (
        <div className="space-y-4">
            {/* Sub-tab Navigation */}
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {subTabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveSubTab(tab.id)}
                            className={`
                                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                                ${activeSubTab === tab.id
                                    ? 'border-indigo-500 text-indigo-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }
                            `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Sub-tab Content */}
            <div className="mt-6">
                {activeSubTab === 'applications' && (
                    <GeneralInsuranceList userRole={userRole} user={user} />
                )}
                {activeSubTab === 'my-policies' && (
                    <GIPoliciesCommissionSubTab />
                )}
                {activeSubTab === 'payouts' && (
                    <GIPayoutsSubTab userRole={userRole} />
                )}
                {activeSubTab === 'monthly-summary' && (
                    <GIMonthlySummarySubTab />
                )}
            </div>
        </div>
    );
};
